import { Controller } from "stimulus"

export default class extends Controller{

  submit() {
    this.element.requestSubmit();
  }

  clickFileInput(event) {
    event.preventDefault();
    this.element.querySelector("#photo-input").click();
  }
}
